import React from 'react';
import FileUploadReportForm from '../FileUploadReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const FaceLivenessInputComponent = () => (
    <FileUploadReportForm
        banner={{ icon: 'pi-eye', title: 'Face Liveness', subtitle: 'Verify a face image is from a live person via Surepass liveness check' }}
        fileFields={[
            { name: 'file', label: 'Face image', accept: 'image/*', maxSizeBytes: 5 * 1024 * 1024, hint: 'JPG / PNG up to 5 MB', colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{ path: '/surepass/face/liveness' }}
        consentReportType="face-liveness"
        submitLabel="Run Liveness Check"
        successSummary="Liveness check complete"
        errorSummary="Liveness check failed"
        confirmHeader="Confirm liveness check"
        confirmAcceptLabel="Yes, check"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Face Liveness Result', icon: 'pi-eye' }}
    />
);

export default FaceLivenessInputComponent;
